module.exports = __webpack_public_path__ + "static/media/expenseTracker.ca20b2e0.jpg";